module.exports = __webpack_public_path__ + "img/bread-account-center-usability.b42eb9d5.png";